import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { usePageTitle } from "@/hooks/usePageTitle";

export default function Blog() {
  usePageTitle("Blog");
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    api.get("/cms/posts").then(({ data }) => setPosts(data));
  }, []);

  return (
    <div className="py-20">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="text-[11px] uppercase tracking-widest text-white/40 font-mono">Updates · Blog</div>
        <h1 className="font-display text-4xl lg:text-6xl mt-3 tracking-tighter">
          The <span className="gradient-text">field notes</span>.
        </h1>
        <div className="mt-14 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {posts.map((p) => (
            <Link to={`/blog/${p.slug}`} key={p.id}
                  className="glass rounded-2xl overflow-hidden hover:border-white/25 transition-colors group">
              {p.cover_image && (
                <div className="aspect-[16/10] overflow-hidden">
                  <img src={p.cover_image} alt={p.title}
                       className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                </div>
              )}
              <div className="p-5">
                <div className="flex items-center gap-2 text-[10px] uppercase tracking-widest text-white/40 font-mono">
                  {(p.tags || []).slice(0, 2).map((t) => <span key={t}>{t}</span>)}
                </div>
                <h3 className="font-display text-xl mt-2.5 leading-tight">{p.title}</h3>
                <p className="mt-2 text-sm text-white/60">{p.excerpt}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
